import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import DataTable from  "@cloudpremise/portal_core/src/themes/mui/examples/Tables/DataTable";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";

const RoutingRules = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const defaultState = {
        maintenanceMode: false,
        maintenanceImageUrl: "",
        maintenanceMessage: "",
        allowBypass: false,
        banner: false,
        bannerText: "We are performing scheduled maintenance on 01/25/2024. We should be back online shortly after the maintenance.",
        bannerColor: "#FFAB00",
        textColor: "#000000",
        bannerCanClose: true,
        bannerTimeOn: "2025-01-20 11:58:00",
        bannerTimeOff: "2025-01-22 11:58:00",
        allowBundleDomain: true,
        proteusLeadObject: "sfLead",
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function handleCheckbox(e, name){
        setState({
            ...state,
            [name]: e.target.checked,
        });
    }
    if(!authorized || !user.superAdmin){
        return null;
    }
    function getItems(){
        const tableData = {
            columns: [
                { Header: "Rule", accessor: "rule", width: "20%" },
                { Header: "Condition", accessor: "condition", width: "25%" },
                { Header: "Target Site", accessor: "site" },
                { Header: "Actions", accessor: "actions", width: "12%", sortable: false },
            ],
            rows: [
                {
                    rule: "A/B Test Group A",
                    condition: "cookie[ab] = A",
                    site: "alpha.olympus-grid.com",
                    actions: (
                        <MDButton
                            variant="gradient"
                            color="info"
                            // onClick={() => handleRowAction(caseObj, {value: "edit"})}
                            iconOnly
                            style={{marginRight: "5px"}}
                            size="small"
                        >
                            <EditIcon />
                        </MDButton>
                    )
                },
                {
                    rule: "IP Isolation (QA Team)",
                    condition: "ip in 192.168.10.0/24",
                    site: "qa.olympus-grid.com",
                    actions: (
                        <MDButton
                            variant="gradient"
                            color="info"
                            // onClick={() => handleRowAction(caseObj, {value: "edit"})}
                            iconOnly
                            style={{marginRight: "5px"}}
                            size="small"
                        >
                            <EditIcon />
                        </MDButton>
                    )
                },
                {
                    rule: "VIP Users",
                    condition: "header[x-user-role] = VIP",
                    site: "vip.olympus-grid.net",
                    actions: (
                        <MDButton
                            variant="gradient"
                            color="info"
                            // onClick={() => handleRowAction(caseObj, {value: "edit"})}
                            iconOnly
                            style={{marginRight: "5px"}}
                            size="small"
                        >
                            <EditIcon />
                        </MDButton>
                    )
                }
            ]
        };

        return tableData;
    }
    const tableDataItems = getItems();
    return (
        <MDBox>
            <Card>
                <MDBox p={2}>
                    <MDBox
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                        mb={2}
                    >
                        <MDTypography component="h5" variant="h5" fontWeight="bold" color="dark">
                            Routing Rules
                        </MDTypography>
                        <MDButton variant="contained" color="dark">
                            Manage Routing Rules
                        </MDButton>
                    </MDBox>
                    <DataTable
                        table={tableDataItems}
                        canSearch={false}
                        entriesPerPage={false}
                        rowsCount={tableDataItems.rows.length}
                    />
                </MDBox>
            </Card>
        </MDBox>
    )
}

export default RoutingRules;